import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const About = () => {
    return (
        <>

        {/* About Start */}
    <section className="container-xxl py-5 fundisha-marketing-section" style={{ paddingTop: 'calc(var(--af-nav-height) + 2.2rem)' }}>
        <div className="container">
            <div className="row g-5">
                <div className="col-lg-6 wow fadeInUp about-image-container" data-wow-delay="0.1s">
                    <div className="position-relative h-100">
                        <img className="img-fluid position-absolute w-100 h-100 about-img-cover" src="img/about.jpg" alt="" />
                    </div>
                </div>
                <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                    <p className="fundisha-marketing-kicker">About Us</p>
                    <h1 className="mb-4 fundisha-marketing-heading">Welcome to Fundisha</h1>
                    <p className="mb-4">
                        Fundisha is your gateway to quality education. We provide a platform where students can access
                        high-quality courses from expert instructors around the world.
                    </p>
                    <p className="mb-4">
                        Our mission is to make education accessible to everyone, everywhere. We believe in the power
                        of online learning to transform lives and create opportunities for growth and development.
                    </p>
                    <div className="row gy-2 gx-4 mb-4">
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                Skilled Instructors
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                Online Classes
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                International Certificate
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                Interactive Learning
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                Flexible Schedule
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p className="mb-0">
                                <FaArrowRight className="text-primary me-2" />
                                Career Support
                            </p>
                        </div>
                    </div>
                    <a className="btn btn-primary py-3 px-5 mt-2" href="/courses">
                        Explore Courses
                    </a>
                </div>
            </div>
        </div>
    </section>
    {/* About End */}
        </>
    )

}
export default About;